import React from 'react'

const HomeHeroSection = () => {
  return (
    <div className='hero-section'>
    <div className='hero-section-title mt-4'>
    <h1>Discover Wesa Pefa Academy</h1>

    <p className='mt-4'>Nuturing minds,Building futures where every child is guided to reach their full potential
       through balanced and holistic education.
    </p>
    </div>
   
  </div> 
  )
}

export default HomeHeroSection